import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { AuthenticationService } from '../core/authentication.service';
import { UpdatePasswordComponent } from './update-password/update-password.component';
import { UserService } from 'app/core/user.service';
import { NotificationsService } from 'app/utils/notifications.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  entryComponents: [ UpdatePasswordComponent],
  declarations: [ LoginComponent, UpdatePasswordComponent],
  exports: [LoginComponent],
  providers: [AuthenticationService, UserService, NotificationsService]
})

export class AuthenticationModule {}




// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/authentication/authentication.module.ts